export const customBtn =
  "pointer-events-auto rounded-md text-xs bg-brand-500 px-3 py-2 text-[0.8125rem] font-semibold leading-5 text-white hover:bg-brand-600 disabled:cursor-not-allowed";

export const gallery =
  "rounded-[4px] bg-[#f5f5f5] mb-3 w-[80px] h-[80px] flex items-center justify-center flex-row hover:cursor-pointer";

export const ORDER_STATUS = ["PROCESSING", "CONFIRMED", "CANCELLED"];

export const WEB_ORDER_STATUS = ["PENDING","CONFIRMED", "PROCESSING", "CANCELLED" , "FULFILLED"];

export const PAYMENT_STATUS = ["PAID", "PRE_PAID", "UNPAID"];

export const BILL_TYPE = ["RECEIPT", "INVOICE"];

export const PAYMENT_METHOD = ["BANK TRANSFER", "CASH", "POS"];

export const ROLES = ["INVENTORY", "SALES", "MANAGER", "CEO"];

export const FREQUENCY = ["MONTHLY", "WEEKLY", "DAILY"];

export const Frequency = {
  MONTHLY: "MONTHLY",
  WEEKLY: "WEEKLY",
  DAILY: "DAILY",
};

export const InvoiceSize = {
  SMALL: "SMALL",
  LARGE: "LARGE",
};
